import Vue from 'vue'
let DRAW_CALL_BACK
let drawControlAddedFeatures = {}
let drawControlUpdatedFeatures = {}
let drawControlDeletedFeatures = {}
const state = Vue.observable({ activated: false, control: null })
/**
 *
 * @param {object} geojson
 */
export const activeDraw = (geojson) => {
  state.activated = true
  state.control.changeMode('simple_select')

  if (geojson) {
    state.control.add(geojson)
  }
}

export const draw = (type, callback, options) => {
  if (!state.activated) {
    throw new Error('Need to active draw first')
  }

  state.control.changeMode(type, options)
  DRAW_CALL_BACK = callback
}
/**
 *
 * @param {({ added: { [string]: object }, updated: { [string]: object }, deleted: { [string]: object }, geojson: object }) => void} callback
 */
export const saveDraw = (callback) => {
  if (!state.activated) {
    throw new Error('Need to enable edit mode first')
  }

  if (!(callback instanceof Function)) {
    throw new Error('Callback is not available')
  }

  const result = {
    added: {},
    updated: {},
    deleted: drawControlDeletedFeatures,
  }

  const collection = state.control.getAll()

  for (let i = 0; i < collection.features.length; i++) {
    const feature = collection.features[i]

    if (drawControlAddedFeatures[feature.id]) {
      result.added[feature.id] = feature
    } else if (drawControlUpdatedFeatures[feature.id]) {
      result.updated[feature.id] = feature
    }
  }

  result.geojson = collection

  callback(result)

  clearDraw()
}
export const clearDraw = () => {
  state.activated = false

  drawControlAddedFeatures = {}
  drawControlDeletedFeatures = {}
  drawControlUpdatedFeatures = {}
  if (!state.control) return

  state.control.deleteAll()
  state.control.changeMode('simple_select')
}
export const cancelDraw = () => {
  clearDraw()
}
export const clearData = () => {
  if (!state.control) return

  state.control.deleteAll()
  state.control.changeMode('simple_select')
}

/**
 *
 * @param {object} event
 * @param {string} event.type 'draw.created'
 * @param {Array<object>} event.features Array of GeoJSON objects representing the features that were created
 */
export const onDrawCreated = (event) => {
  for (const feature of event.features) {
    drawControlAddedFeatures[feature.id] = true
  }

  if (DRAW_CALL_BACK) {
    saveDraw(DRAW_CALL_BACK)
    DRAW_CALL_BACK = undefined
  }
}

/**
 *
 * @param {object} event
 * @param {string} event.type 'draw.delete'
 * @param {Array<Feature>} event.features Array of GeoJSON objects representing the features that were deleted
 */
export const onDrawDeleted = (event) => {
  for (const feature of event.features) {
    if (drawControlAddedFeatures[feature.id]) return

    drawControlDeletedFeatures[feature.id] = feature
  }
}
/**
 * @param {object} event
 * @param {string} event.action Name of the action that triggered the update (move, change_coordinates)
 * @param {string} event.type 'draw.update'
 * @param {Array<Feature>} event.features Array of features that were updated
 */
export const onDrawUpdated = (event) => {
  for (const feature of event.features) {
    if (drawControlAddedFeatures[feature.id]) return

    drawControlUpdatedFeatures[feature.id] = true
  }
}
export default () => state
